<template>
    <main class="product-card-container" ref="pdfcontent">
        <h1>{{translate('product_card_number')}} <span>{{this.cardNumber}}{{this.offerVersion}}</span>
            <br>{{translate('fan')}}
            <span>{{this.$store.state.activeFun.type}} {{this.$store.state.activeFun.model}}</span></h1>

        <custom-listcomponent :data="getProductCards.basic"/>
        <custom-listcomponent :data="getProductCards.input_data"/>
        <custom-listcomponent :data="getProductCards.work_parameters" :comments="true"/>
        <custom-table-component :data="getProductCards.execution"/>
        <custom-table-component :data="getProductCards.work_restrictions" :comment="translate('work_restrictions_comment')"/>
        <custom-listcomponent :data="getProductCards.engine"/>
        <corrosion-protection :data="getProductCards.corrosion_protection" @updatePrice="updateFinalPrice" :key="$store.state.productCard['custom'].corrosion_protection.values['class_category'].value" v-if="!getProductCards.corrosion_protection.values.coating"/>
        <custom-listcomponent :data="getProductCards.corrosion_protection" v-else/>
        <custom-listcomponent :data="getProductCards.fan"/>
        <custom-listcomponent :data="getProductCards.accesories"/>
        <additional-information-component :data="getPricingData" :currency="currency" :type="'summary'"
                                          @updatePrice="updateFinalPrice" @updateDiscount="updateFinalDiscount" v-if="renderComponent"/>
        <!-- NVS-148 -->
        <additional-information-component :data="getProductCards.comment" type="comment" v-if="getProductCards.comment"/>
        <additional-information-component :data="getProductCards.delivery"/>
        <section class="graph-informations" :style="{'display': graphInformationShow?'block':'none'}">
            <fan-graph-summary :offer-view="true"/>
            <graph-parts-collapse :offer-view="true"/>
            <custom-listcomponent :data="getProductCards.work_parameters" :custom-title-code="'work_point'"/>
            <!--<fans-table :load="false" v-show="false"/>-->
            <!-- NVS-79 -->
            <div class="flow_characteristics">{{ translate('flow_characteristics') }}</div>
            <fan-graphs :offer-view="true" v-if="showDetailed"/>
            <measurement-comment v-if="false"/>
            <!-- klucze mają na celu tylko przerysowanie komponentów w przypadku zmiany języka, idki muszą być unikatowe -->
            <octave-graphs :data="getActiveFan" :graphs="['la56','lpa','lpa_prim']" :key="translate('send')" :id="'octave_1'" />
            <octave-graphs :data="getActiveFan" :graphs="['lwa','lwa3','lwa4']" :key="translate('send_offer_version')" :id="'octave_2'" v-if="parseInt(getActiveFan.data.octave_graphs_lwa34)" />
            <resistance-torque :data="getActiveFan" />
            <engine-start-time :data="getActiveFan" />
            <connections :data="getProductCards.connections" />
            <section class="full-page-render">
                <img src="" alt="Fan Render" class="fan-render-image-convertable">
            </section>
        </section>

        <div class="full-render-download-section">
            <a :href="`https://admin.wentylatory.netecs.pl/api/Went/apiFan/getFanRenderRaw?id=${this.$store.state.activeFun.selectedFanData.id_app_fan_image}&fan=${this.$store.state.activeFun.type.toLocaleUpperCase()}_${this.$store.state.activeFun.model.replace(/\//gi, '-')}`">
                <i class="icon-doc"/>&nbsp;{{translate('download_fan_render')}}
            </a>
        </div>

        <div class="navi-btns">
            <router-link to="/selection_of_the_offer" class="back-btn circle-btn">
            </router-link>
            <button type="button"
                    class="summary-btn"
                    v-if="($store.state.userRole === 'admin' || $store.state.userRole === 'user') && !isApproved && !isSent"
                    @click="sendData">
                {{translate("send")}}
            </button>
            <button type="button"
                    class="summary-btn"
                    v-if="$store.state.userRole === 'admin' && isSent && !isApproved"
                    @click="sendData">
                {{translate('send_offer_version')}}
            </button>
            <button type="button"
                    class="summary-btn"
                    v-if="$store.state.userRole === 'admin' && isSent && !isApproved"
                    @click="sendData($event, true)">
                {{translate('send_new_version')}}
            </button>
            <button type="button"
                    v-if="$store.state.userRole === 'admin' && showApproveButton && approveButtonFlagDisplay"
                    class="admin-btn"
                    @click="approveOffer">
                {{translate('confirm')}}
            </button>
            <button type="button"
                    class="summary-btn"
                    @click="generatePDF">
                <InlineLoader v-if="pdfInAction"/>
                <template v-else>
                    {{translate("print_to_pdf")}}
                </template>
            </button>
            <button type="button"
                    class="summary-btn"
                    v-if="$store.state.userRole === 'admin'"
                    @click="generateCurrencyPDF">
                <InlineLoader v-if="pdfInAction"/>
                <template v-else>
                    {{translate("print_to_pdf")}} (PLN)
                </template>
            </button>
            <button type="button"
                    class="summary-btn"
                    @click="copyToClipboard">
                {{translate("copy_to_clipboard")}}
            </button>
            <modal v-show="isModalVisible"
                   @close="closeModal"
                   @approve="sendData">
            </modal>
        </div>
    </main>
</template>

<script>
    import customListcomponent from "../components/ResultForm/customListComponent";
    import corrosionProtection from "../components/ResultForm/corrosionProtection";
    import connections from "../components/ResultForm/connections";
    import resistanceTorque from "../components/ResultForm/resistanceTorque"
    import engineStartTime from "../components/ResultForm/engineStartTime"
    import octaveGraphs from "../components/ResultForm/octaveGraphs"

    import customTableComponent from "../components/ResultForm/customTableComponent";
    import additionalInformationComponent from "../components/ResultForm/additionalInformationComponent";
    import Modal from "../components/ResultForm/modal";
    import measurementComment from "../components/ResultForm/measurementComment";

    import FanGraphSummary from "../components/configuration_steps/fourthStep/FanGraphSummary";
    import FansTable from "@/components/configuration_steps/fourthStep/FansTable";
    import FanGraphs from "../components/configuration_steps/fourthStep/FanGraphs";
    import WorkPointCollapse from "@/components/configuration_steps/fourthStep/WorkPointCollapse";
    import GraphPartsCollapse from "@/components/configuration_steps/fourthStep/GraphPartsCollapse";
    import InlineLoader from "../components/InlineLoader";
    import ErpBafa from "@/erpBafa";

    import html2canvas from 'html2canvas';

    export default {
        name: "ResultForm",
        components: {
            InlineLoader,
            Modal,
            additionalInformationComponent,
            customTableComponent,
            customListcomponent,
            connections,
            FanGraphSummary,
            FansTable,
            FanGraphs,
            measurementComment,
            WorkPointCollapse,
            GraphPartsCollapse,
            resistanceTorque,
            engineStartTime,
            octaveGraphs,
            corrosionProtection
        },
        prop: ['isCustom'],
        data() {
            return {
                cardId: 0,
                isModalVisible: false,
                cadNumber: false,
                cardNumber: '-',
                isInAction: false,
                afterSendApproval: false,
                approveButtonFlagDisplay: true,
                showDetailed: true,
                graphInformationShow: true,
                pageContent: '',
                pdfInAction: false,
                currency: false,
                renderComponent: true,
            }
        },
        methods: {
            calculateDiscount(price) {
                return parseFloat(this.$priceController.calculateDiscount(price, this.$store.state.discount, this.getDiscountsValue())).toFixed(2);
            },

            calculateDiscountRaw(price) {
                return this.$priceController.calculateDiscountRaw(price, this.$store.state.discount);
            },

            generateCurrencyPDF() {
                const code = 'PLN';
                if (this.$store.state.currenciesList) {
                    let currency = this.$store.state.currenciesList.find(x => x.currency === code);
                    if (currency) {
                        this.currency = currency;
                        this.generatePDF();
                        setTimeout(() => {
                            this.currency = false;
                        }, 10);
                    }
                }

            },

            updateFinalPrice(rerender = false) {
                let summary = this.$store.state.productCard.custom.summary.values;
                summary['zz_summary_price']['value'] = `${this.getFanTotalPriceSummary()} EUR`;
                if(rerender) this.forceRerender();
            },

            forceRerender() {
                this.renderComponent = false;
                this.$nextTick().then(() => { this.renderComponent = true; });
                return false;
            },

            // NVS-95
            updateFinalDiscount() {
                this.$store.state.discount.additionalDiscount = this.getDiscountsValue();
                this.updateFinalPrice()
            },

            getActiveFanPrice() {
                return this.$store.state.activeFun.params.price;
            },

            getAccessories() {
                return this.$store.state.productCard.custom.accesories;
            },

            getFanCount() {
                return this.$store.state.workPointParameters.elements.number_of_fans.value;
            },

            getSurchargesPrice() {
                let summary = this.$store.state.productCard.custom.summary.values;

                let surchargePrice = 0;
                if (summary) {
                    for (let key in summary) {
                        if (summary.hasOwnProperty(key)) {
                            if (key.includes('surcharge_')) {
                                surchargePrice += this.calculateDiscountRaw(summary[key].price);
                            }
                        }
                    }
                }
                return surchargePrice;
            },

            // NVS-95
            getDiscountsValue() {
                let summary = this.$store.state.productCard.custom.summary.discounts;

                let discount = 0;
                if (summary) {
                    for (let key in summary) {
                        if (summary.hasOwnProperty(key)) {
                            if (key.includes('discount_')) {
                                discount += parseFloat(summary[key].discount);
                            }
                        }
                    }
                }
                return discount;
            },

            sumAdditionalAccessoriesPrice() {
              let sum = 0;

              this.$store.state.productCard.custom.accesories.values.add_accessories.values.forEach((accesory) => {
                if (accesory.isActive) {
                  sum += parseFloat(this.calculateDiscount(parseFloat(accesory.price)));
                }
              });

              this.$store.state.productCard.custom.accesories.sumAdditionalAccessoriesPrice = sum;
              return sum;
            },

            getFanTotalPriceSummary() {
                return this.$priceController.convertWithThousandSeparator(parseFloat(`${parseFloat(this.calculateDiscount(this.getActiveFanPrice())) + (parseInt(this.getFanCount()) * this.sumAdditionalAccessoriesPrice()) + this.getSurchargesPrice()}`).toFixed(2));
            },

            updatePageContent() {
                this.graphInformationShow = true;

                return new Promise(resolve =>
                    setTimeout(() => {
                        this.pageContent = document.body.outerHTML;
                        this.graphInformationShow = false;
                        resolve();
                    }, 10));
            },

            // NVS-194
            async copyToClipboard() {
                await this.updatePageContent();
                let domParser = new DOMParser();
                let content = domParser.parseFromString(this.pageContent, 'text/html');

                [
                    'div.logo-container',
                    'div.lang_options-container',
                    'p.description',
                    'div.verification-notification',
                    'div.lang',
                    'div.backgroundimg-fixed',
                    'section.graph-informations',
                    'section.octave-graphs-container',
                    'section.connections-informations',
                    'section.full-page-render',
                    'div.icon-dh',
                    'div.items-container',
                    'div.fanGraphs',
                    'div.graph-wrapper',
                    'div.custom_wrapper',
                    'span.performance-axis-label',
                    'span.axis-unit-span',
                    'div.execution-zones',
                    'noscript',
                    'a',
                    'header',
                    'footer',
                    'button',
                    'line',
                    'g',
                    'svg',
                    'aside',
                    'iframe',
                    'script',
                    'math',
                    'msub',
                    'mn',
                    'sub',
                    'foreignObject',
                    'img',
                    'input',
                ].forEach(selector => {
                    content.querySelectorAll(selector).forEach(element => element.remove());
                });
                content.querySelectorAll('span.title').forEach(element => {
                    element.querySelectorAll('div').forEach(div => {
                        while (div.firstChild) {
                            element.insertBefore(div.firstChild, div);
                        }
                        div.remove();
                    });
                    element.innerHTML = `${element.innerHTML}: `;
                });
                content.querySelectorAll('section.accessories-informations').forEach((section, index) => {
                    section.querySelectorAll('div.execution-atex').forEach(div => {
                        const first = div.querySelector('span.value');
                        const second = first.nextSibling;
                        first.innerHTML = `${this.translate(index === 0 ? 'inside' : 'minimum')}: ${first.innerHTML}`;
                        second.innerHTML = ` | ${this.translate(index === 0 ? 'outside' : 'maximum')}: ${second.innerHTML}`;
                    });
                });
                content.querySelectorAll('span.value').forEach(span => span.style.fontWeight = 'bold');
                content.querySelectorAll('span.PLN_value').forEach(span => {
                    span.style.fontWeight = 'bold';
                    span.innerHTML = `${span.innerHTML} | `;
                });
                const graphs = document.querySelector('section.graph-informations');
                graphs.style.display = 'block';
                const canvas = await html2canvas(document.querySelector('div.graph-wrapper'));
                const img = document.createElement('img');
                img.src = canvas.toDataURL('image/png');
                content.body.appendChild(img);
                graphs.style.display = 'none';

                const clipboardItem = new ClipboardItem({
                    "text/html": new Blob(
                    [content.documentElement.outerHTML],
                    { type: "text/html" }
                ),});
                await navigator.clipboard.write([clipboardItem]);
                this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, this.translate('copy_to_clipboard'), this.translate('copy_success'));
            },

            async generatePDF() {
                await this.updatePageContent();
                let content = this.pageContent;
                if (this.pdfInAction) return;
                this.pdfInAction = true;
                let data = new FormData();
                data.append('content', content);
                if (this.$store.state.activeFun.selectedFanData.id_app_fan_image) {
                    data.append('app_fan_image_id', this.$store.state.activeFun.selectedFanData.id_app_fan_image);
                }
                data.append('id_offer_temp', this.$store.state.productCard.custom.id_offer_temp);
                this.$apiController.getSinglePdf(data)
                    .then((res) => {
                        if (res.status === 'success') {
                            const linkSource = `data:application/pdf;base64,${res.data.file}`;
                            const downloadLink = document.createElement("a");
                            let fileName = `${this.$store.state.activeFun.type.toLocaleUpperCase()}_${this.$store.state.activeFun.model.replace(/\//gi, '-')}_${this.cardNumber}${this.offerVersion === undefined ? '' : this.offerVersion}.pdf`;

                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                            this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, 'PDF', this.translate('pdf_generate_success'));
                        } else {
                            this.$notifications.add(this.$notifications.TYPES.ERROR, 'PDF', this.translate('pdf_generate_fail'));
                        }
                        this.pdfInAction = false;
                    })
                    .catch((e) => {
                        console.error(e);
                        this.pdfInAction = false;
                    });

                if (this.$store.getters.getUserRole === 'admin') {
                    if (this.$store.state.activeFun.data.comment_enabled) {
                        if (this.$store.state.activeFun.data.comment) {
                            let comment = this.$store.state.activeFun.data.comment;

                            data = new FormData();
                            data.append('content', comment);
                            data.append('id_offer_temp', this.$store.state.productCard.custom.id_offer_temp);

                            this.$apiController.getSinglePdf(data)
                                .then((res) => {
                                    if (res.status === 'success') {
                                        const linkSource = `data:application/pdf;base64,${res.data.file}`;
                                        const downloadLink = document.createElement("a");
                                        let fileName = `Comment-${this.$store.state.activeFun.type.toLocaleUpperCase()}_${this.$store.state.activeFun.model.replace(/\//gi, '-')}_${this.cardNumber}${this.offerVersion === undefined ? '' : this.offerVersion}.pdf`;

                                        downloadLink.href = linkSource;
                                        downloadLink.download = fileName;
                                        downloadLink.click();
                                        // this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, 'PDF', this.translate('pdf_generate_success'));
                                    } else {
                                        // this.$notifications.add(this.$notifications.TYPES.ERROR, 'PDF', this.translate('pdf_generate_fail'));
                                    }
                                    this.pdfInAction = false;
                                })
                                .catch((e) => {
                                    // console.error(e);
                                    // this.pdfInAction = false;
                                    this.$notifications.add(this.$notifications.TYPES.ERROR, 'PDF', this.translate('pdf_generate_fail') + " on comment");
                                });

                        }
                    }
                }

            },

            async sendData(e, makeNewOffer = false) {
                if (!this.isInAction) {
                    this.isInAction = true;
                    this.$apiController.sendOffer(await this.parseFormData(makeNewOffer))
                        .then((res) => {
                            if (res.status === 'success') {
                                this.closeModal();
                                this.$store.state.productCard.custom.id_offer_received = res.data.server_id;
                                this.cardNumber = res.data.server_id;
                                this.isInAction = false;
                                this.afterSendApproval = true;
                                this.$store.state.productCard.custom.id_offer_db = res.data.id;
                                let version = res.data.version;
                                let notificationContent = `${this.translate('your_offer_has_been_sent')}`;
                                if (version > 0) {
                                    Vue.set(this.$store.state.productCard.custom, 'version', version);
                                    notificationContent += `. ${this.translate('offer_version')} ${version}`;
                                }
                                this.$store.state.productCard.loaded = this.$store.state.productCard.custom;
                                this.updatePageContent();
                                this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, this.translate('offer_sent_success_header'), notificationContent);
                            } else if (res.status === 'error') {
                                if (Array.isArray(res.message)) {
                                    for (let error of res.message) {
                                        this.$notifications.add(this.$notifications.TYPES.ERROR, this.translate('offer_sent_error_header'), this.translate(error));
                                    }
                                } else {
                                    this.$notifications.add(this.$notifications.TYPES.ERROR, this.translate('offer_sent_error_header'), this.translate(res.message));
                                }
                                throw new Error(res.message);
                            }
                        });
                }
            },

            downloadRenderImage() {
                return;
                let imageId = this.$store.state.activeFun.selectedFanData.id_app_fan_image;
                let form = new FormData();
                form.append('id', imageId);

                this.$apiController.getFanRender(form).then((res) => {
                    if (res.status === 'success' && res.data !== null) {
                        const linkSource = `data:image/png;base64,${res.data}`;
                        const downloadLink = document.createElement("a");
                        let fileName = `${this.$store.state.activeFun.type.toLocaleUpperCase()}_${this.$store.state.activeFun.model.replace(/\//gi, '-')}_render.png`;

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                });
            },

            approveOffer() {
                if ((this.isSent && this.dbOfferId !== undefined && (!this.isApproved)) || this.afterSendApproval) {
                    let form = new FormData();
                    form.append('id', this.$store.state.productCard.custom.id_offer_db);
                    this.$apiController.approveOffer(form)
                        .then((res) => {
                            if (res.status === 'success') {
                                Vue.set(this.$store.state.productCard.custom, 'is_approved', true);
                                this.afterSendApproval = false;
                                this.approveButtonFlagDisplay = false;
                                this.updatePageContent();
                                this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, this.translate('offer_approved_success'), this.translate('your_offer_has_been_approved'));
                            } else if (res.status === 'error') {
                                if (Array.isArray(res.message)) {
                                    for (let error of res.message) {
                                        this.$notifications.add(this.$notifications.TYPES.ERROR, this.translate('offer_approved_error'), this.translate(error));
                                    }
                                } else {
                                    this.$notifications.add(this.$notifications.TYPES.ERROR, this.translate('offer_approved_error'), this.translate(res.message));
                                }
                                throw new Error(res.message);
                            }
                        });
                }

            },

            printValue(key, element) {
                let value = element.value;
                if (element.hasOwnProperty("paramsTableId") && element['paramsTableId'] != "" && this.$store.state.activeFun) {
                    if (this.$store.state.activeFun.params && this.$store.state.activeFun.params[element['paramsTableId']]) {
                        value = this.$store.state.activeFun.params[element['paramsTableId']];
                    } else {
                        if (element['paramsTableId'] == "fan_type")
                            value = this.$store.state.activeFun.type;
                        else if (element['paramsTableId'] == "fan_type_number")
                            value = this.$store.state.activeFun.model;
                    }
                }

                if (element.hasOwnProperty("requestedValue") && element['requestedValue'] != "" && this.$store.state.fourthStepParametersSelected[element.requestedValue])
                    value = this.$store.state.fourthStepParametersSelected[element.requestedValue].value;

                if (element.hasOwnProperty("calculated")) {
                    let selectedFanData = this.$store.state.activeFun.selectedFanData;
                    value = 0;

                    switch (key) {
                        case "weight":
                            if (selectedFanData)
                                value = parseFloat(selectedFanData.mass) + parseFloat(this.$store.state.activeFun.engine.weight)
                            break;
                        case "pipeline_average_speed":
                            value = parseFloat(this.getWorkPointParameters.elements['performance'].value / (Math.PI * Math.pow((this.$store.state.fourthStepParametersSelected["pipeline_diameter"].value / 2), 2))).format(2);
                            value = value.replace(',', '.');
                            break;
                        case "average_rated_speed_of_the_fan":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data)
                                value = parseFloat((this.getWorkPointParameters.elements["work_frequency"].value / 50) * this.$store.state.activeFun.data.avg_nominal_speed).toFixed(0);
                            break;
                        case "minimum_amount_of_air_at_the_minimum_frequency":
                            var minimum_frequency_on_the_inverter1 = 0;

                            if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.selectedFanData) {
                                if (this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.number_of_fans_on_the_inverter.options[0].elements) == "0") {
                                    minimum_frequency_on_the_inverter1 = this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);
                                } else {
                                    minimum_frequency_on_the_inverter1 = Math.sqrt((this.getWorkPointParameters.elements[this.getPressureType() + '_pressure'].value / this.getWorkPointParameters.elements["maximum_" + this.getPressureType() + '_pressure'].value) * Math.pow(this.$store.state.activeFun.data.network_frequency, 2))
                                }

                                if (minimum_frequency_on_the_inverter1 < this.$store.state.activeFun.selectedFanData.min_frequency)
                                    minimum_frequency_on_the_inverter1 = this.$store.state.activeFun.selectedFanData.min_frequency;

                                value = (minimum_frequency_on_the_inverter1 / this.getWorkPointParameters.elements['work_frequency'].value) * this.getWorkPointParameters.elements['minimum_air_amount'].value;
                            }

                            break;
                        case "maximum_rotor_speed":
                            if (selectedFanData)
                                value = parseFloat(selectedFanData.max_speed);
                            break;

                        case "casing_dimensions":
                            if (selectedFanData)
                                value = selectedFanData.external_dimensions;
                            break;

                        case "electrical_power":

                            if (this.$store.state.activeFun && this.$store.state.activeFun.engine && this.$store.state.activeFun.engine.efficiency_3_4)
                                value = (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / parseFloat(this.$store.state.activeFun.engine.efficiency_3_4));
                            break;

                        case "electrical_power_with_material":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.engine && this.$store.state.activeFun.engine.efficiency_3_4)
                                value = (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / parseFloat(this.$store.state.activeFun.engine.efficiency_3_4));
                            break;

                        case "amperage_v1":
                            var voltages = this.getActiveFunVoltages();
                            var calculated = 0;

                            if (voltages && this.$store.state.activeFun && this.$store.state.activeFun.engine) {
                                if (voltages.length > 0)
                                    calculated = 1000 * (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / (voltages[0] * Math.sqrt(3) * this.$store.state.activeFun.engine.power_factor * this.$store.state.activeFun.engine.efficiency_3_4));
                            }

                            value = calculated;
                            break;
                        case "amperage_v2":
                            var voltages = this.getActiveFunVoltages();
                            var calculated = 0;

                            if (voltages && this.$store.state.activeFun && this.$store.state.activeFun.engine) {
                                if (voltages.length > 1)
                                    calculated = 1000 * (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / (voltages[1] * Math.sqrt(3) * this.$store.state.activeFun.engine.power_factor * this.$store.state.activeFun.engine.efficiency_3_4));
                            }

                            value = calculated;
                            break;
                        case "characteristic_coefficient":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data.characteristic_coefficient)
                                value = parseFloat(this.$store.state.activeFun.data.characteristic_coefficient).toFixed(3);
                            break;

                        case "average_length_of_the_shredded_material":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data) {
                                var number_of_fans = (this.$store && this.$store.state && this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data['number_of_fans']) ? this.$store.state.activeFun.data['number_of_fans'] : 1;
                                var v_wlot = this.getWorkPointParameters.elements['performance'].value / (Math.PI * 0.25 * Math.pow((0.001 * this.$store.state.activeFun.data.avg_inlet), 2));
                                var average_rated_speed_of_the_fan = (this.getWorkPointParameters.elements["work_frequency"].value / 50) * this.$store.state.activeFun.data.avg_nominal_speed;

                                var l_sr = (v_wlot / ((this.getWorkPointParameters.elements['work_frequency'].value / 50) * average_rated_speed_of_the_fan / 60 * this.$store.state.activeFun.data.blades_amount)) / number_of_fans;

                                value = l_sr;
                            }
                            break;
                        case "minimum_frequency_on_the_inverter":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.selectedFanData) {
                                if (this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.number_of_fans_on_the_inverter.options[0].elements) == "0") {
                                    value = this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);
                                } else {
                                    value = Math.sqrt((this.getWorkPointParameters.elements[this.getPressureType() + '_pressure'].value / this.getWorkPointParameters.elements["maximum_" + this.getPressureType() + '_pressure'].value) * Math.pow(this.$fanObjParamsManager.getNetwork_frequency(this.$store), 2))

                                    if (value < this.$store.state.activeFun.selectedFanData.min_frequency)
                                        value = this.$store.state.activeFun.selectedFanData.min_frequency;
                                }
                            }
                            break;
                        case "fan_temperature_increase":
                            if(this.$store.state.activeFun && this.$store.state.activeFun.selectedFanData) {
                                value = (this.getWorkPointParameters.elements['total_pressure'].value / (this.getWorkPointParameters.elements['air_density'].value * 1000 * this.getWorkPointParameters.elements['total_efficiency'].value)) + 273.15;
                            }
                            break;
                        default:
                            break;
                    }
                }
                if (this.countSimilarFans == 0)
                    return "-";
                else
                    return this.calcUnit(key, value);
            },
            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },

            getPressureType() {
                if (this.$store.state.fourthStepParametersSelected.pressure.options[0].elements[0].active == true) {
                    return this.$store.state.fourthStepParametersSelected.pressure.options[0].elements[0].value;
                } else {
                    return this.$store.state.fourthStepParametersSelected.pressure.options[0].elements[1].value;
                }
            },

            getActiveFunVoltages() {
                if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data.network_frequency && this.$store.state.activeFun.engine) {
                    let frequency = this.$store.state.activeFun.data.network_frequency;

                    let voltage = this.$store.state.activeFun.engine['voltage_' + frequency + '_hz'];

                    if (voltage) {
                        let voltages = voltage.split("/");

                        return voltages;
                    }
                }

                return [];
            },

            async parseGraphsToHTMLString() {
                await this.updatePageContent();
                let domParser = new DOMParser();
                let content = domParser.parseFromString(this.pageContent, 'text/html');

                let svgs = {};

                let fanGraphSummary = content.querySelector('.fanGraphSummary');
                svgs['fanGraphSummary'] = fanGraphSummary.outerHTML;

                let fanGraphs = content.querySelector('.fanGraphs');
                svgs['fanGraphs'] = fanGraphs.outerHTML;

                return svgs;
            },

            checkIfFanHasBafa(fan, frequency) {
              let query = fan.name;
              let form = new FormData();
              form.append('type_number', query);
              return new Promise(((resolve, reject) => {
                this.$apiController.getFanByTypeNumberHandshake(form)
                    .then((res) => {
                      if (res.status === 'error') {
                        if(res.message == "fan_not_erp"){
                          resolve(false);
                        }else{
                          console.error("Nieobsłużony wyjątek ERP BAFA!!!");
                        }
                        // this.$notifications.add(this.$notifications.TYPES.WARNING, 'BAFA / ERP', this.translate(res.message));
                      } else if (res.status === 'success') {
                        if (res.data.fan_max_frequency < frequency) {
                          resolve(false)
                        }
                        resolve(true)
                      }
                    }).catch((e)=>{
                      reject(e);
                })
              }))
            },

            async parseFanBafa() {
              let fan = this.$store.state.activeFun;
              let workOnInverter = !this.$store.state.fourthStepParametersSelected.work_on_the_inverter.options[0].elements[0].active;
              let frequency = this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[0].active?50:60;

              let bafaResult = await this.checkIfFanHasBafa(fan.selectedFanData, frequency);
              if(!bafaResult) return false;

              let forcedData = {
                  engine: fan.engine
              }

              let bafaCalculator = new ErpBafa(this.$store, workOnInverter, frequency, frequency, fan.selectedFanData, this.$calculator, true, forcedData);
              let result = bafaCalculator.calculate();

              return result;
            },

            async parseFormData(makeNewOffer) {
                let offerData = this.$store.state.productCard.custom;
                offerData['fourth_step_parameters_selected'] = this.$store.state.fourthStepParametersSelected;
                offerData['active_fan'] = this.$store.state.activeFun;
                offerData['discount'] = this.$store.state.discount;
                offerData['params_table'] = this.$store.state.fansTableData.params_table;
                offerData['parts_of_the_graph'] = this.$store.state.partsOfTheGraph;

                let graphsData = await this.parseGraphsToHTMLString();

                let bafaTables = await this.parseFanBafa();

                if(bafaTables) {
                  offerData['bafa_tables'] = bafaTables;
                }

                let graphsSummary = {
                    workPointPressure: window.measurementShow.graphsSummary.data.workPointPressure,
                    workPointPerformance: window.measurementShow.graphsSummary.data.workPointPerformance,
                    workPointPerformanceHour: window.measurementShow.graphsSummary.data.workPointPerformanceHour
                };

                offerData['graphs_summary'] = graphsSummary;
                offerData['graphs_svg'] = graphsData;
                offerData['selected_work_point'] = this.$store.state.selectedWorkPoint;
                delete offerData['active_fan']['imgSrc'];

                let lastPathParameters = {
                    selectedFirstStepElement: JSON.parse(JSON.stringify(this.$store.state.selectedFirstStepElement)),
                    selectedSecondStepElement: JSON.parse(JSON.stringify(this.$store.state.selectedSecondStepElement)),
                    selectedThirdStepElement: JSON.parse(JSON.stringify(this.$store.state.selectedThirdStepElement))
                };

                offerData['last_path_parameters'] = lastPathParameters;

                let currentDate = new Date();
                currentDate = currentDate.toISOString().slice(0, 10);
                offerData.basic.values.creation_date.value = currentDate;

                // NVS-170
                if (makeNewOffer) {
                    offerData.version = 0
                    offerData.id_offer_temp = this.generateTempOfferId();
                    offerData.basic.values.prepared_by.value = this.$store.getters.getUsername;
                    this.cardNumber = offerData.id_offer_temp;
                }

                let form = new FormData();

                form.append('offer_data', JSON.stringify(offerData));
                form.append('client', offerData.basic.values.client.value);

                if (this.$store.state.productCard.custom.id_offer_received !== '-' && !makeNewOffer) {
                    form.append('update', 1);
                }
                if (makeNewOffer) {
                    form.append('force_new_offer', 1);
                }

                form.append('id_offer_temp', offerData.id_offer_temp);

                return form;
            },

            showModal() {

                if (this.isCustom) {
                    if (this.cadNumber == !this.cadNumber) {
                        this.isModalVisible = false;
                    } else {
                        this.isModalVisible = true;
                    }
                } else {
                    this.sendData();
                }
            },

            closeModal() {
                this.isModalVisible = false;
            },

            clearValues() {
                for (let category in this.$store.state.productCard.custom) {
                    if (this.$store.state.productCard.custom.hasOwnProperty(category)) {
                        category = this.$store.state.productCard.custom[category];
                        if (category.hasOwnProperty('values')) {
                            for (let element in category) {
                                if (category.hasOwnProperty(element)) {
                                    for (let prop in category[element]) {
                                        let custom = category[element];

                                        if (custom[prop].hasOwnProperty('value')) custom[prop].value = '-';
                                        if (custom[prop].hasOwnProperty('inside_value')) custom[prop].inside_value = '-';
                                        if (custom[prop].hasOwnProperty('outside_value')) custom[prop].outside_value = '-';
                                        if (custom[prop].hasOwnProperty('inside_variable')) {
                                            delete custom[prop].inside_variable;
                                        }
                                        if (custom[prop].hasOwnProperty('outside_variable')) {
                                            delete custom[prop].outside_variable;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;
            },

            calcUnit(key, value) {

                if (value == "nieobliczalne" || value == "+nieskończoność" || value == "-nieskończoność")
                    return "-";

                if (!this.$store.state.ValueUnitMap[key] || !this.$store.state.ValueUnitMap[key].value != "" || !this.$store.state.ValueUnitMap[key].selected)
                    return value;

                let param = {value: value};
                let option = {elements: {1: this.$store.state.ValueUnitMap[key].selected}};

                let arg = {
                    type: 'calcUnit',
                    param: param,
                    option: option,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            fillZerosDate(stamp) {
                stamp = stamp.toString();
                if (stamp.length === 1) {
                    stamp = '0' + stamp;
                }
                return stamp;
            },

            generateTempOfferId() {
                const LOCAL_ID_FLAG = 'OL';
                let userId = this.$store.state.userId;
                let now = new Date();
                let year = now.getFullYear();
                let month = this.fillZerosDate(now.getMonth() + 1);
                let day = this.fillZerosDate(now.getDate());

                let hour = this.fillZerosDate(now.getHours());
                let minutes = this.fillZerosDate(now.getMinutes());
                let seconds = this.fillZerosDate(now.getSeconds());

                let milliseconds = now.getMilliseconds();

                return `${LOCAL_ID_FLAG}-${userId}-${year}${month}${day}-${hour}${minutes}${seconds}-${milliseconds}`;
            },

            getUnit(key) {

                if (key === "pipeline_average_speed")
                    return "[m/s]";

                if (key === "price")
                    return "[EUR]";

                if (key === 'casing_dimensions')
                    return "[mm]";

                if (key === 'maximum_rotor_speed')
                    return "[1/min]";

                if (key === 'average_rated_speed_of_the_fan')
                    return "[1/min]";

                if (key === "characteristic_coefficient")
                    return "[-]";

                if (key === "casing_dimensions")
                    return "[mm]";

                if (key === "drive")
                    return "[-]:&nbsp;";

                if (key == "fan_temperature_increase")
                    return "[°C]";

                if (this.$store.state.ValueUnitMap[key] && this.$store.state.ValueUnitMap[key].value != "" && this.$store.state.ValueUnitMap[key].selected && this.$store.state.ValueUnitMap[key].selected.value)
                    return "[" + this.$store.state.ValueUnitMap[key].selected.value + "]";
                else
                    return "";
            }
        },

        computed: {
            getWorkPointParameters() {
                return this.$store.state.workPointParameters;
            },

            getProductCards() {
                return this.$store.state.productCard.custom;
            },

            getPricingData() {
                // NVS-207 - usunięcie dodatków, których już nie można wybrać na wczesniejszej stronie
                Object.keys(this.$store.state.productCard.custom.summary.values).forEach(key => {
                    if (key.includes('fan_extra_name_') && !this.$store.state.productCard.custom.accesories.values.add_accessories.values.find(value => value.id == key.replace('fan_extra_name_', ''))) {
                        delete this.$store.state.productCard.custom.summary.values[key];
                    }
                });
                return this.$store.state.productCard.custom.summary;
            },

            getActiveFan() {
                return this.$store.state.activeFun;
            },

            isCustom() {
                return this.$store.state.productCard.loaded;
            },

            isSent() {
                return this.$store.state.productCard.custom.id_offer_received !== '-';
            },

            dbOfferId() {
                return this.$store.state.productCard.custom.id_offer_db;
            },

            isApproved() {
                return this.$store.state.productCard.custom.is_approved;
            },

            isCancelled() {
                return this.$store.state.productCard.custom.is_cancelled;
            },

            isExActive() {
                return this.$store.state.fourthStepParametersSelected.ex.options[0].elements[1].active;
            },

            isAdmin() {
                return this.$store.getters.getUserRole == 'admin'
            },

            offerVersion() {
                let version = this.$store.state.productCard.custom.version;
                if (version !== undefined) {
                    if (version > 0) {
                        return '-' + version;
                    }

                } else return null;
            },

            showApproveButton() {
                if (this.afterSendApproval) return true;
                if (this.isCancelled && !this.isApproved) return true;
                if (this.isApproved) {
                    return false;
                }
                if (this.dbOfferId === '-' || this.dbOfferId === undefined) {
                    return false;
                }
                return true;
            }

        },
        mounted() {
            setTimeout(() => {
                this.showDetailed = true;
                this.updatePageContent();
            }, 50); //Brak promisea i jednoczesne ladowanie komponentow niepoprawnie zaczytywalo dane

            let workPoint = this.$store.state.workPointParameters;
            let accessories = this.$store.state.productCard['custom'].accesories.values;
            let activeFan = this.$store.state.activeFun;
            let customAtex = this.$store.state.productCard.custom.execution.values;

            // NVS-159 Usuwam nawet jeśli są w zapisanej ofercie
            delete customAtex.explosion_category;
            delete customAtex.device_category;
            delete customAtex.anti_explosion_protection_type;
            delete customAtex.temperature_class;

            if (!this.isCustom) {
                //RESET VALUES
                this.clearValues();

                //NAMING OFFER WITH TEMP ID
                this.$store.state.productCard.custom.id_offer_temp = this.generateTempOfferId();

                //USER
                this.$store.state.productCard.custom.basic.values.prepared_by.value = this.$store.getters.getUsername;

                //OFFER TEMP ID
                this.cardNumber = this.$store.state.productCard.custom.id_offer_temp;

                //DELIVERY DEFAULTS
                let customDelivery = this.$store.state.productCard.custom.delivery.values;
                customDelivery.delivery_time['variable'] = true;
                customDelivery.delivery_expiration_date['variable'] = true;

                let currentDate = new Date();
                currentDate = currentDate.toISOString().slice(0, 10);
                this.$store.state.productCard['custom']['basic']['values']['creation_date'].value = currentDate;
                this.cardId = 'custom';

                //FIND MEDIUM
                let customFan = this.$store.state.productCard['custom'].fan.values;
                let medium = this.$store.state.selectedThirdStepElement;

                if (medium.name) {
                    customFan.medium.value = medium.name;
                } else {
                    let step = this.$store.state.thirdStepElements.find(x => x.id = medium.id);
                    customFan.medium.value = step.title_translation_code;
                }

                // NVS-175 - przeniesienie resetowania do wartosci domyślnej
                const defaultValue = this.$store.state.offerAntiCorrosion.find(x => x.is_standard == 1)
                setTimeout(() => {
                    this.$store.commit({
                        type: 'selectElementOfCorrosionProtectionValues',
                        valueId: defaultValue.id,
                        elementKey: 'class_category',
                        connectedKey: 'coating_thickness',
                        connectedValue: defaultValue.coating,
                        surcharge: defaultValue.surcharge_code,
                    });
                    this.updateFinalPrice();
                }, 0);
            }
            
            //CONNECTIONS
            if (this.$store.state.activeFun && this.$store.state.productCard['custom'].connections) {
                let customConn = this.$store.state.productCard['custom'].connections.values;
                if(activeFan.suctionConnection.image && activeFan.suctionConnection.image != '') {
                    this.$store.state.productCard['custom'].connections.view = true;
                    customConn.suction.isDisabled = false;
                    customConn.suction.image = activeFan.suctionConnection.image;
                    customConn.suction.diameter = activeFan.suctionConnection.diameter;
                    customConn.suction.norm = activeFan.suctionConnection.norm;
                }
                if(activeFan.pressingConnection.image && activeFan.pressingConnection.image != '') {
                    this.$store.state.productCard['custom'].connections.view = true;
                    customConn.pressing.isDisabled = false;
                    customConn.pressing.image = activeFan.pressingConnection.image;
                    customConn.pressing.diameter = activeFan.pressingConnection.diameter;
                    customConn.pressing.outlet_a = activeFan.pressingConnection.outlet_a;
                    customConn.pressing.outlet_b = activeFan.pressingConnection.outlet_b;
                    customConn.pressing.norm = activeFan.pressingConnection.norm;
                }
            }
            
            //FAN

            let customFan = this.$store.state.productCard['custom'].fan.values;

            if (this.$store.state.activeFun) {
                customFan.fan_type.value = activeFan.type;
                customFan.type_number.value = activeFan.model;

                //PRICE

                customFan.fan_genre.value = this.$store.state.selectedFirstStepElement.name;
                customFan.number_of_fans.value = workPoint.elements.number_of_fans.value;
                customFan.rotor.value = 'rotor_' + activeFan.data.rotor_type;

                customFan.drive.value = 'drive_' + activeFan.selectedFanData.drive;
            }
            
            //ENGINE
            let customEngine = this.$store.state.productCard['custom'].engine.values;

            if (this.$store.state.activeFun.engine) {
                let engine = this.$store.state.activeFun.engine;

                customEngine.producer.value = engine.manufacturer;
                customEngine.motor_designation.value = engine.designation;
                customEngine.efficiency_class.value = engine.efficiency_class;

                customEngine.motor_poles.value = this.$store.state.activeFun.params.number_of_poles;

                if (this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements[0].active) {
                    customEngine.rated_speed.value = engine.speed_50_hz;
                    customEngine.frequency.value = '50 [Hz]';
                    customEngine.rated_voltage.value = engine.voltage_50_hz;
                    customEngine.rated_power.value = engine.power_50_hz + ' [kW]';
                } else {
                    customEngine.rated_speed.value = engine.speed_60_hz;
                    customEngine.rated_voltage.value = engine.voltage_60_hz;
                    customEngine.frequency.value = '60 [Hz]';
                    customEngine.rated_power.value = engine.power_60_hz + ' [kW]';
                }

                customEngine.rated_speed.value += ' [1/min]';
                customEngine.rated_voltage.value += ' [V]';

                customEngine.protection_class.value = "IP55";

                //NVS-147  
                if (!customEngine.work_on_inverter_possibility) customEngine.work_on_inverter_possibility = {
                    title: "work_on_inverter_possibility",
                    value: "yes",
                    translation: true
                } 
                customEngine.work_on_inverter_possibility.value = 'yes';
                customEngine.work_on_inverter_possibility.translation = true;
            }
            
            //WORK RESTRICTIONS

            let workRestrictions = this.$store.state.productCard.custom.work_restrictions.values;
            if (activeFan) {
                workRestrictions.material_temperature.inside_value = activeFan.selectedFanData.medium_temperature_from + ' [°C]';
                workRestrictions.material_temperature.outside_value = activeFan.selectedFanData.medium_temperature_to + ' [°C]';

                workRestrictions.rotor_speed.outside_value = activeFan.selectedFanData.max_speed + ' [1/min]';

                workRestrictions.ambient_temperature.inside_value = activeFan.selectedFanData.ambient_temperature_from + ' [°C]';
                workRestrictions.ambient_temperature.outside_value = activeFan.selectedFanData.ambient_temperature_to + ' [°C]';
            }
            
            //ATEX EXECUTION

            // NVS-176
            if (!this.isExActive) {
                customAtex.zone['inside_value'] = '-';
                customAtex.zone['outside_value'] = '-';
                customAtex.ex_signature['inside_value'] = '-';
                customAtex.ex_signature['outside_value'] = '-';
            }

            if (activeFan.params.standardVersion.version_id !== activeFan.params.version.version_id) {
                let atexId = this.$store.state.relationsFanAtexes.find(x => x.fan_id === activeFan.id && x.version_id === activeFan.params.version.version_id);
                let atex = this.$store.state.atexesList.find(x => x.id === atexId.id);
                if (atex !== undefined) {

                    //ZONE
                    customAtex.zone['inside_value'] = atex.zone_inside;
                    customAtex.zone['outside_value'] = atex.zone_outside;

                    /* NVS-116
                    //EXPLOSION CATEGORY
                    customAtex.explosion_category['inside_value'] = atex.explosion_group_inside;
                    customAtex.explosion_category['outside_value'] = atex.explosion_group_outside;

                    //DEVICE CATEGORY
                    customAtex.device_category['inside_value'] = atex.category_inside;
                    customAtex.device_category['outside_value'] = atex.category_outside;

                    //ANTIEXPLOSION
                    customAtex.anti_explosion_protection_type['inside_value'] = atex.explosion_protection_inside;
                    customAtex.anti_explosion_protection_type['outside_value'] = atex.explosion_protection_outside;

                    //TEMPERATURE CLASS
                    customAtex.temperature_class['inside_value'] = atex.temperature_class_inside;
                    customAtex.temperature_class['outside_value'] = atex.temperature_class_outside;
                    */

                    //DESIGNATION
                    customAtex.ex_signature['inside_value'] = atex.designation_inside;
                    customAtex.ex_signature['outside_value'] = atex.designation_outside;
                }
                // IP55 IP65 MAPPING
                if (activeFan) {
                  /////////////////////////////
                  // let result = 'IP55';
                  // let ip65fans = this.$store.state.fansInAtexTypes;
                  // let fanType = activeFan.selectedFanData.id_type;
                  // if (atex && atex.zone === '21' && atex.type === 'inside' && ip65fans.indexOf(fanType) !== -1) {
                  //   result = 'IP65'
                  // } else if (atex && atex.zone === '21' && atex.type === 'inside') {
                  //   result = 'IP55'
                  // } else if (atex && atex.zone === '21' && (atex.type === 'both' || atex.type === 'outside')) {
                  //   result = 'IP65'
                  // } else {
                  //   result = 'IP55'
                  // }
                  /////////////////////////////
                  let result = 'IP55';

                  if (atex && atex.zone_inside === '21' && (atex.type === 'both' || atex.type === 'outside')) {
                    result = 'IP65'
                  }

                    customEngine.protection_class.value = result;
                }
            }

            //TRANSITIONS

            let activeUnit = this.$store.state.fourthStepParametersSelected.pipeline_diameter.options[0].elements.find(x => x.active === true).value;
            let pipelineDiameter = this.calcUnit('pipeline_diameter', this.$store.state.fourthStepParametersSelected.pipeline_diameter.value) + ' [' + activeUnit + ']';

            if (accessories.add_accessories.values.find(x => x.id == 16 && x.isActive) || accessories.included_accessories.values.find(x => x.id == 16)) {
                customFan['transition_on_pressing'].isDisabled = false;
                customFan['default_pressing_connection_type'].isDisabled = false;
                customFan.transition_on_pressing.value = pipelineDiameter;
            }

            if (accessories.add_accessories.values.find(x => x.id == 19 && x.isActive) || accessories.included_accessories.values.find(x => x.id == 19)) {
                customFan['transition_on_suction'].isDisabled = false;
                customFan['default_suction_connection_type'].isDisabled = false;
                customFan.transition_on_suction.value = pipelineDiameter;
            }

            //INPUT PARAMETERS
            let _this = this;

            function addInputParameter(key, value, translation = false) {
                if (isNaN(value)) {
                    translation = true;
                } else {
                    value = _this.calcUnit(key, value) + " " + _this.getUnit(key);
                }
                Vue.set(_this.$store.state.productCard.custom.input_data.values, key, {
                    'title': key,
                    'value': value,
                    'calc': true,
                    'unit': true,
                    translation
                });
            }

            let fourthStepParameters = this.$store.state.fourthStepParametersSelected;
            for (let paramName in fourthStepParameters) {
                if (this.$store.state.fourthStepParametersSelected.hasOwnProperty(paramName)) {
                    if (!fourthStepParameters[paramName].active) continue;
                    if (paramName === 'pressure') {
                        for (let paramOption in fourthStepParameters[paramName].options) {
                            if (fourthStepParameters[paramName].options[paramOption]['type'] === 'radio') {
                                let activeRadioValue = '';
                                for (let radio in fourthStepParameters[paramName].options[paramOption].elements) {
                                    if (fourthStepParameters[paramName].options[paramOption].elements[radio].active) {
                                        activeRadioValue = fourthStepParameters[paramName].options[paramOption].elements[radio].value;
                                    }
                                }
                                if (activeRadioValue !== '') {
                                    addInputParameter('workPointPressure', activeRadioValue, true);
                                }
                            }
                        }
                    }
                    if (fourthStepParameters[paramName].hasOwnProperty('value')) {
                        addInputParameter(paramName, fourthStepParameters[paramName].value);
                    } else if (fourthStepParameters[paramName].hasOwnProperty('options')) {
                        if (fourthStepParameters[paramName].options.hasOwnProperty(0)) {
                            for (let paramOption in fourthStepParameters[paramName].options) {
                                if (fourthStepParameters[paramName].options[paramOption]['type'] === 'radio') {
                                    let activeRadioValue = '';
                                    for (let radio in fourthStepParameters[paramName].options[paramOption].elements) {
                                        if (fourthStepParameters[paramName].options[paramOption].elements[radio].active) {
                                            activeRadioValue = fourthStepParameters[paramName].options[paramOption].elements[radio].value;
                                        }
                                    }
                                    if (activeRadioValue !== '') {
                                        if (paramName === 'fan_position') paramName = 'fan_location';
                                        if (paramName === 'network_frequency') {
                                            activeRadioValue = activeRadioValue + ' [Hz]';
                                            addInputParameter(paramName, activeRadioValue, false);
                                        } else {
                                            addInputParameter(paramName, activeRadioValue, true);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            //WORK PARAMETERS
            function addWorkParameter(key, value, additionalTitle = false) {
                if (value === '-') return;
                value = value + " " + _this.getUnit(key);
                Vue.set(_this.$store.state.productCard.custom.work_parameters.values, key, {
                    'title': key,
                    'value': value,
                    'calc': true,
                    'additionalTitle': additionalTitle
                });
            }

            for (let paramName in workPoint.elements) {
                if (workPoint.elements.hasOwnProperty(paramName)) {
                    if (workPoint.elements[paramName].active) {
                        let element = workPoint.elements[paramName];
                        let value = this.printValue(paramName, element);
                        if (element.displayCountOfFans) {
                            if (workPoint.elements.number_of_fans.value > 1) {
                                value = workPoint.elements.number_of_fans.value + 'x ' + value;
                            }
                        }
                        if (paramName === 'amperage_v1') {
                            let amperage_voltage = this.getActiveFunVoltages();
                            if (amperage_voltage[0] !== undefined) {
                                addWorkParameter(paramName, value, amperage_voltage[0]);
                            }
                        } else if (paramName === 'amperage_v2') {
                            let amperage_voltage = this.getActiveFunVoltages();
                            if (amperage_voltage[1] !== undefined) {
                                addWorkParameter(paramName, value, amperage_voltage[1]);
                            }
                        } else {
                            addWorkParameter(paramName, value);
                        }
                    }
                }
            }

            // SORT WORK PARAMETERS BETWEEN EACH OTHER
            (function () {
                function switchPlaces(array, up, to) {
                    let upIndex = array.indexOf(up);
                    let toIndex = array.indexOf(to);

                    if (upIndex * toIndex < 0) return;

                    let buffer = array[toIndex];
                    array[toIndex] = array[upIndex];
                    array[upIndex] = buffer;
                    return array;
                }

                let raw = this.$store.state.productCard.custom.work_parameters.values;
                let sorted = {};

                let order = Object.keys(raw);

                const changes = [
                    {
                        up: 'total_pressure',
                        to: 'static_pressure'
                    },
                    {
                        up: 'pipeline_average_speed',
                        to: 'work_frequency'
                    },
                    {
                        up: 'installed_power',
                        to: 'material_amount'
                    }
                ];
                if (!this.$store.state.productCard.loaded && !this.$store.state.productCard.paramsFlipped) {
                    for (let change of changes) {
                        if (raw.hasOwnProperty(change.up) && raw.hasOwnProperty(change.to)) {
                            order = switchPlaces(order, change.up, change.to);
                        }
                    }

                    for (let value of order) {
                        sorted[value] = raw[value];
                    }

                    this.$store.state.productCard.custom.work_parameters.values = sorted;
                    this.$store.state.productCard.paramsFlipped = true;
                }
            }.bind(this))();

            //FAN POSITION
            delete this.$store.state.productCard['custom'].basic.values['fan_position'];

            if (this.$store.state.accessories.fan_positions) {
                for (let fanPosition of this.$store.state.accessories.fan_positions) {
                    if (fanPosition.active) {
                        this.$store.state.productCard['custom'].fan.values.fan_position.value = fanPosition.name;
                    }
                }
            }

            //CORROSION PROTECTION

            let validationData = this.$store.state.productCard.custom.summary_form;
            let corrosion = this.$store.state.productCard['custom'].corrosion_protection.values;

            corrosion.fan_color_rest.value = validationData.fan_color_rest.value;
            corrosion.fan_engine_color.value = validationData.fan_engine_color.value;
            corrosion.fan_cover_color.value = validationData.fan_cover_color.value;

            corrosion.fan_color_rest.translation = true;
            corrosion.fan_engine_color.translation = true;
            corrosion.fan_cover_color.translation = true;

            if(this.isExActive && !this.isAdmin) {
                corrosion.fan_color_rest.value = 'antistatic_paint';
                corrosion.fan_engine_color.value = 'antistatic_paint';
                corrosion.fan_cover_color.value = 'antistatic_paint';
            }
            if(this.isAdmin) {
                const fan_color_rest = this.$store.state.translations.find(el => el.value == corrosion.fan_color_rest.value)
                if(fan_color_rest) corrosion.fan_color_rest.value = fan_color_rest.code

                const fan_engine_color = this.$store.state.translations.find(el => el.value == corrosion.fan_engine_color.value)
                if(fan_engine_color) corrosion.fan_engine_color.value = fan_engine_color.code

                const fan_cover_color = this.$store.state.translations.find(el => el.value == corrosion.fan_cover_color.value)
                if(fan_cover_color) corrosion.fan_cover_color.value = fan_cover_color.code
            }

            //WRONG MAPPED BY END USER - TO FIX
            if (activeFan) {
                let maximumTemperature = activeFan.selectedFanData.medium_temperature_to;
                if (maximumTemperature) {
                    if (parseInt(maximumTemperature) <= 120) {
                        corrosion.underlay_thickness.value = '120&nbsp;&deg;C';
                    } else {
                        corrosion.underlay_thickness.value = maximumTemperature + '&nbsp;&deg;C';
                    }
                }
            }

            //BASIC

            let basic = this.$store.state.productCard['custom'].basic.values;

            basic.client.value = validationData['client'] ? validationData['client'].value : this.$store.state.userCompany;
            // NVS-148
            // if (validationData['comment'].value === '') {
            //     basic.comment.value = '-'
            // } else {
            //     basic.comment.value = validationData['comment'].value;
            // }
            basic.project_number.value = (validationData['project_number'].value === '') ? '-' : validationData['project_number'].value;
            basic.commission.value = (validationData['commission'].value === '') ? '-' : validationData['commission'].value;

            if (this.$store.state.productCard.loaded) {
                this.cardNumber = this.$store.state.productCard.custom.id_offer_received;
            }

            //COMMENT
            // NVS-148
            let comment = this.$store.state.productCard['custom'].comment;
            if(comment) {
                if (validationData['comment'].value === '') comment.value = '-';
                else comment.value = validationData['comment'].value;
            }

            //SUMMARY
            let fanCount = parseInt(this.$store.state.workPointParameters.elements.number_of_fans.value);
            let summary = this.$store.state.productCard.custom.summary;
            if (summary) {
                let fanCountPrefix = '';
                if (fanCount > 1) {
                    fanCountPrefix = `${fanCount}x `;
                }
                summary = summary.values;
                summary['fan']['count_prefix'] = fanCountPrefix;
                summary['fan']['title'] = 'fan';
                summary['fan']['suffix'] = this.$store.state.activeFun.type + " " + this.$store.state.activeFun.model;
                summary['fan']['price_before_discount'] = this.getActiveFanPrice();
                summary['fan']['value'] = this.calculateDiscount(this.getActiveFanPrice()) + " EUR";

                let accessories = [
                    ...this.$store.state.productCard['custom'].accesories.values.included_accessories.values,
                    ...this.$store.state.productCard['custom'].accesories.values.add_accessories.values
                ];

                for (let i in accessories) {
                    if (accessories.hasOwnProperty(i)) {
                        if (accessories[i].isActive) {
                            summary[accessories[i].title] = {
                                count_prefix: fanCountPrefix,
                                title: accessories[i].title,
                                suffix: '',
                                price_before_discount: (fanCount * accessories[i].price),
                                value: this.calculateDiscount(fanCount * accessories[i].price) + " EUR",
                                is_accessories: true,
                                hidePrice: accessories[i].hidePrice,
                                image: accessories[i].image,
                                is_image_visible: accessories[i].is_image_visible,
                                type: accessories[i].type,
                            };
                        } else {
                            delete summary[accessories[i].title];
                        }
                    }
                }

                summary['zz_summary_price'] = {title: '', value: '', summary_title: ''};
                summary['zz_summary_price']['summary_title'] = 'summary_price';
                summary['zz_summary_price']['value'] = `${this.getFanTotalPriceSummary()} EUR`;
            }
        }
    }
</script>
